import {Controller} from "stimulus"
import $ from 'jquery';
import {add_direct_product_to_cart, create_array_for_product, create_shopping_cart} from "./b2b_controller";
import {unBlockElementById} from "./blockUI_controller";
import bootbox from "bootbox";
import {validate} from "./validate_controller";

let date_disabled = [];
let flatpick_lang;

export default class extends Controller {
    static targets = ["productType"];

    connect() {
    }

    page(e) {
        let page_e = e;
        bootbox.dialog({
            title: 'Campos requeridos',
            message: `<div id="campos_reserva" class="col-12 row" data-controller="preferences datime">
                        <div class="form-group col-12">
                          <label for="safari_date_group" data-preferences-target="dateCollect"></label>
                          <input id="safari_date_group" type="text" class="form-control required">
                          <span class="helper-text small"></span>
                        </div>
                        <!-- EXCURSION UBICACION -->
                        <div id="excursion_location_container" class="form-group col-12">
                          <label for="excursion_location"> ${I18n.t('reservation.side_bar.pickup_place')}</label>
                          <input id="excursion_location" type="text" class="form-control required" placeholder="${I18n.t('reservation.side_bar.pickup_place')}" data-action="preferences#make_comment" data-text="Ubicación: ">
                          <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                        </div>
                        <!-- EXCURSION IDIOMA -->
                        <div id="excursion_lang_container" class="form-group col-12">
                          <label for="excursion_lang"> ${I18n.t('reservation.side_bar.lang')}</label>
                          <select id="excursion_lang" class="form-control required"></select>
                          <span class="helper-text small"></span>
                        </div>
                      </div>`,
            size: 'extra-large',
            buttons: {
                cancel: {
                    label: "Cancelar",
                    className: 'btn-secondary'
                },
                ok: {
                    label: "Aceptar",
                    className: 'btn-success',
                    callback: function (e) {
                        /*let check = $('#terms_and_condition_accepted');
                        if (check.is(':checked')) {
                            resolve({
                                success: true
                            })
                        } else {
                            toastr.warning('Debe acceptar nuestros terminos y condiciones para continuar', 'Términos y condiciones');
                            return true;
                        }*/
                        /*validate('campos_reserva').then(r => {
                            console.info(r);
                            console.info(page_e.target.dataset.product_id); // product_id
                        })*/
                        // Llamada a la función validate

                        // Desactivar el cierre automático del cuadro de diálogo
                        return false;
                    }
                }
            },
            onShown: function () {
                // Agregar un evento personalizado al botón "Aceptar"
                $('.bootbox-accept').on('click', function () {
                    validate('campos_reserva').then(r => {
                        if (r.next === false) {
                            // Validación fallida: mostrar advertencia y mantener el cuadro de diálogo abierto
                            toastr.warning('Por favor, complete los campos requeridos para continuar.', 'Campos requeridos');
                        } else {
                            let product_id = e.target.dataset.product_id; // product_id
                            let product_type = e.target.dataset.product_type; // product_type
                            let destination_id = e.target.dataset.destination_id; // destination_id
                            let destination_code = e.target.dataset.destination_code; // destination_code
                            let text_destination = e.target.dataset.text_destination; // text_destination
                            let category_id = e.target.dataset.category_id; // category_id
                            let category_code = e.target.dataset.category_code; // category_code
                            let modalities_name = e.target.dataset.modalities_name; // modalities_name
                            let modalities_code = e.target.dataset.modalities_code; // modalities_code
                            let dealer_code = e.target.dataset.dealer_code; // dealer_code
                            let dealer_name = e.target.dataset.dealer_name; // dealer_name
                            let dealer_id = e.target.dataset.dealer_id; // dealer_id
                            let calc_amount = e.target.dataset.calc_amount; // calc_amount
                            let adult = e.target.dataset.adult; // adult
                            let children = e.target.dataset.children; // children
                            let pax = e.target.dataset.pax; // pax
                            let min_length_reservation = e.target.dataset.min_length_reservation; // min_length_reservation
                            let max_length_reservation = e.target.dataset.max_length_reservation; // max_length_reservation

                            create_array_for_product('id', product_id); // product_id
                            create_array_for_product('product_type', product_type); // product_type
                            create_array_for_product('destination_id', destination_id); // destination_id
                            create_array_for_product('destination_code', destination_code); // destination_code
                            create_array_for_product('text_destination', text_destination); // text_destination
                            create_array_for_product('category_id', category_id); // category_id
                            create_array_for_product('category_code', category_code); // category_code
                            create_array_for_product('modalities_name', modalities_name); // modalities_name
                            create_array_for_product('modality_code', modalities_code); // modalities_code
                            create_array_for_product('dealer_code', dealer_code); // dealer_code
                            create_array_for_product('dealer_name', dealer_name); // dealer_name
                            create_array_for_product('dealer_id', dealer_id); // dealer_id
                            create_array_for_product('calc_amount', calc_amount); // calc_amount
                            create_array_for_product('adult', adult); // adult
                            create_array_for_product('children', children); // children
                            create_array_for_product('pax', pax); // pax
                            create_array_for_product('amount', '1'); // pax
                            create_array_for_product('min_length_reservation', min_length_reservation); // min_length_reservation
                            create_array_for_product('max_length_reservation', max_length_reservation); // max_length_reservation
                            // console.info(location.origin);

                            create_shopping_cart('static-page-group', product_type).then(shopc => {
                                if (shopc.next) {
                                    /*if (e.target.dataset.addtocart === 'true') {*/
                                    add_direct_product_to_cart('static-page-group', dealer_code, category_id, '1', product_type, modalities_code).then(
                                        product_add => {
                                            if (product_add.next) {
                                                location.href = `${location.origin}/${sessionStorage.getItem('locale')}/shopping_cart`
                                            } else {
                                                toastr.error('No se pudo añadir el producto', 'Carrito de compra')
                                            }
                                        }
                                    )
                                    /*} else {
                                        setTimeout(function () {
                                            toastr.error('No se ha podido agregar el producto al carrito', 'Error');
                                            unBlockElementById('static-page-group');
                                        }, 1000);
                                    }*/
                                } else {
                                    // setTimeout(function () {
                                    toastr.info('Se creó el No se ha podido agregar el producto al carrito', 'Carrito de compra');
                                    unBlockElementById('static-page-group');
                                    // }, 1000);
                                }
                            })

                            // Validación exitosa: cerrar el cuadro de diálogo
                            bootbox.hideAll();
                        }
                    }).catch(error => {
                        console.error("Error durante la validación:", error);
                        toastr.error('Ocurrió un error durante la validación.', 'Error');
                    });
                });
            }
        })
    }
}